import * as React from 'react';
import { Col, Modal, Row } from 'antd';
import styled from 'styled-components';
import { DrawerModal } from '../Mobile/Modal/DrawerModal';
import { useDeviceDetect } from '../../hooks/useDeviceQuery.hook';
import { Button } from '../ButtonV2/ButtonV2';
import { Typography } from '../DesignSystemV2/Typography';

interface WarningModalV2Props {
  isModalOpen: boolean;
  onOk?: () => void;
  title: string;
  icon: any;
  children: any;
  okButtonText?: string;
  isShowFooter?: boolean;
  closable?: boolean;
}

const ModalComponent = ({ closable, visible, onOk, children, isShowFooter, okButtonText }) => {
  const { isMobile } = useDeviceDetect();
  return isMobile ? (
    <DrawerModal onOk={onOk} visible={visible} okButtonText={okButtonText} footer={isShowFooter}>
      {children}
    </DrawerModal>
  ) : (
    <ModalContainer
      width={442}
      closable={closable}
      destroyOnClose
      visible={visible}
      footer={
        isShowFooter ? (
          <Button.Primary key="submit" onClick={onOk}>
            {okButtonText}
          </Button.Primary>
        ) : null
      }
    >
      {children}
    </ModalContainer>
  );
};

const WarningModalV2 = (props: WarningModalV2Props) => {
  const {
    onOk,
    title,
    isModalOpen,
    children,
    icon,
    okButtonText,
    isShowFooter = true,
    closable = true,
  } = props;

  return (
    <ModalComponent
      closable={closable}
      isShowFooter={isShowFooter}
      visible={isModalOpen}
      onOk={onOk}
      okButtonText={okButtonText}
    >
      <Row wrap={false}>
        {icon && <StyledCol>{icon}</StyledCol>}
        <StyledCol flex={1}>
          <Typography.Text variant="semi-bold/20">{title}</Typography.Text>
        </StyledCol>
      </Row>
      {children}
    </ModalComponent>
  );
};

export default React.memo(WarningModalV2);

const StyledCol = styled(Col)`
  display: flex;
  align-items: center;
  &:not(:last-child) {
    margin-right: 16px;
  }
`;

const ModalContainer = styled(Modal)`
  .ant-modal-footer {
    padding: 16px 24px;
  }
`;
